import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { serviceListSchema, faqSchema } from "@/lib/home-schema";
import { buildBreadcrumb, localBusinessSchema } from "@/lib/site-schema";

const breadcrumbSchema = buildBreadcrumb([]);

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { name: "twitter:card", content: "summary_large_image" },
      { title: "SEOEVOLUTION | SEO y visibilidad en IA para empresas" },
      {
        name: "description",
        content:
          "SEOEVOLUTION: estrategia personalizada de SEO, Google Maps y visibilidad en respuestas de IA para empresas. Diagnóstico según mercado, competencia y objetivos.",
      },
      {
        name: "keywords",
        content:
          "agencia SEO, posicionamiento web, SEO con IA, SEO inteligencia artificial, agencia SEO España, SEO local, SEO ecommerce, web en React, migración WordPress React, zona exclusiva SEO, consultoría SEO, marketing digital",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://agenciaseoevolution.com/" },
      { property: "og:title", content: "SEOEVOLUTION | SEO y visibilidad en IA para empresas" },
      {
        property: "og:description",
        content:
          "SEOEVOLUTION: estrategia personalizada de SEO, Google Maps y visibilidad en respuestas de IA para empresas. Diagnóstico según mercado, competencia y objetivos.",
      },
      { name: "twitter:title", content: "SEOEVOLUTION | SEO y visibilidad en IA para empresas" },
      {
        name: "twitter:description",
        content:
          "SEOEVOLUTION: estrategia personalizada de SEO, Google Maps y visibilidad en respuestas de IA para empresas. Diagnóstico según mercado, competencia y objetivos.",
      },
    ],
    links: [{ rel: "canonical", href: "https://agenciaseoevolution.com/" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(localBusinessSchema) },
      { type: "application/ld+json", children: JSON.stringify(breadcrumbSchema) },
      { type: "application/ld+json", children: serviceListSchema },
      { type: "application/ld+json", children: faqSchema },
    ],

  }),
  component: Index,
});
